import styles from "./GraphicPropertiesForm.module.scss";

type Props = {
	path: string;
};

/** A resource-bound field is owned by its resource, so the operator cannot set it. */
export default function ResourceBoundField({ path }: Props) {
	return (
		<div className={styles.ResourceBound}>
			<span className={styles.ResourceBoundLabel}>From resource</span>
			<span className={styles.ResourceBoundPath}>{path}</span>
		</div>
	);
}
